var React = require('react');

function FlutterPlain (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M225.2 0L0 225L69.4 294.4L363.4 0.200001H225.5L225.2 0ZM225.5 207.6L104.1 328.6L225.5 450H363.7L242.6 328.7L363.7 207.6H225.5Z","fill":"#00ACD7"}));
}

FlutterPlain.defaultProps = {"viewBox":"0 0 364 450","fill":"none"};

module.exports = FlutterPlain;

FlutterPlain.default = FlutterPlain;
